// extracted by mini-css-extract-plugin
export default {"loadingElipsisContainer":"LoadingElipsis_loadingElipsisContainer__zB0Xq"};